import { type TicketActionTypeEnum } from '@/common/types/case'

export const enum CaseActionModalEnum {
  CANCEL = 'CANCEL',
  COMPLETE = 'COMPLETE',
  COMPLETEONVALIDATION = 'COMPLETEONVALIDATION',
  RELEASE = 'RELEASE',
  REOPEN = 'REOPEN',
  TRANSFER = 'TRANSFER',
  ASSIGN = 'ASSIGN',
  HANDLE_INTERACTIONS = 'HANDLE_INTERACTIONS',
  REASSIGN = 'REASSIGN',
  ESCALATE = 'ESCALATE',
  CATEGORIZE = 'CATEGORIZE',
  ATTACHPARENT = 'ATTACHPARENT',
  ASKFORVALIDATION = 'ASKFORVALIDATION',
  UNDOVALIDATION = 'UNDOVALIDATION',
  APPROVE = 'APPROVE',
  DISAPPROVE = 'DISAPPROVE',
  STACK = 'STACK',
  STACKANDPUTBACKINPOOL = 'STACKANDPUTBACKINPOOL',
  STACKANDREASSIGN = 'STACKANDREASSIGN',
  STACKANDTRANSFER = 'STACKANDTRANSFER',
  UPDATEDUEDATE = 'UPDATEDUEDATE',
  TAKEON = 'TAKEON',
}

export type CaseActionModalType = keyof typeof CaseActionModalEnum

export interface BaseCaseActionDTOV1 {
  comment?: string
  reasonCode?: string
}

export interface CompleteActionDTOV1 extends BaseCaseActionDTOV1 {
  autoCloseInteractions?: boolean
}

export type AskForValidationActionDTOV1 = BaseCaseActionDTOV1

export type ReopenActionDTOV1 = BaseCaseActionDTOV1

export type CancelCaseActionDTOV1 = BaseCaseActionDTOV1

export type UndoValidationCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type ApproveCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type DisapproveCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type ReleaseCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'>

export type AssignCaseActionDTOV1 = Omit<BaseCaseActionDTOV1, 'reasonCode'> & {
  userLogin?: string
}

export type ReassignCaseActionDTOV1 = AssignCaseActionDTOV1

export interface TransferCaseActionDTOV1 extends BaseCaseActionDTOV1 {
  skillCode?: string
}

export interface StackCaseActionDTOV1 extends BaseCaseActionDTOV1 {
  wakeupDate?: string
}

export type StackAndReleaseCaseActionDTOV1 = StackCaseActionDTOV1

export interface StackAndReassignCaseActionDTOV1 extends StackCaseActionDTOV1 {
  userLogin?: string
}

export type StackAndTransferCaseActionDTOV1 = Omit<StackAndReassignCaseActionDTOV1, 'reasonCode'> & {
  transferReasonCode?: string
  putOnHoldReasonCode?: string
  skillCode?: string
}

export interface UpdateDateDueCaseActionDTOV1 extends BaseCaseActionDTOV1 {
  dueDate?: string
}
export type PerformCaseActionPayloadDTOV1 =
  | CompleteActionDTOV1
  | AskForValidationActionDTOV1
  | ReopenActionDTOV1
  | CancelCaseActionDTOV1
  | UndoValidationCaseActionDTOV1
  | ApproveCaseActionDTOV1
  | DisapproveCaseActionDTOV1
  | ReleaseCaseActionDTOV1
  | AssignCaseActionDTOV1
  | ReassignCaseActionDTOV1
  | TransferCaseActionDTOV1
  | StackCaseActionDTOV1
  | StackAndReleaseCaseActionDTOV1
  | StackAndReassignCaseActionDTOV1
  | StackAndTransferCaseActionDTOV1
  | UpdateDateDueCaseActionDTOV1

export interface ListCaseActionsParams {
  'include-empty-comment'?: boolean
  type?: TicketActionTypeEnum[]
  user?: string[]
  page?: number
  size?: number
  'sort-field'?: CaseActionsSortFieldEnum
  'sort-direction'?: CaseActionsSortDirectionEnum
}

export interface BasicCaseActionDTOV1 {
  date: string
  type: TicketActionTypeEnum
  comment?: string
  user?: string
  reasonCode?: string
}

export type CaseActionDTOV1 = BasicCaseActionDTOV1 & {
  id: number
  caseId: number
  afterActionAssigneeLogin?: string
  childToRedirectTo?: number
}

export type CaseActionResponse = CaseActionDTOV1 | CaseActionDTOV1[]

export interface CaseCommentsMetadataDTOV1 {
  number: number
  users: string[]
  actionTypes: TicketActionTypeEnum[]
}

export enum CaseActionsSortFieldEnum {
  DATE = 'DATE',
}

export enum CaseActionsSortDirectionEnum {
  DESCENDING = 'DESCENDING',
  ASCENDING = 'ASCENDING',
}
